import Detect from '@/api/detect.api.js'

/*eslint-disable */
export const getDetect = ({ commit }, data) => {
  return Detect.getDetect(data)
    .then(response => {
      commit("SET_DETECT", response.data)
      return response.data;
    })
}
export const getDetectBox = ({ commit }, data) => {
    return Detect.getDetectBox(data)
        .then(response => {
            commit("SET_AUTO_DETECT", response.data)
            return response.data;
        })
}
/*eslint-enable */
